import { ElementRef, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

export class KeyValueModel {
    key: number;
    value: string;
    isChecked?: boolean;
}
export class ParentFormAndElmModel {
    parentFormToValidate: UntypedFormGroup;
    parentElement: ElementRef;
    parentCdr: ChangeDetectorRef;
    parentFormJustToClear: UntypedFormGroup;
    emitInvalidEvtFlag: boolean;

    constructor(parentFormToValidate: UntypedFormGroup, parentElement: ElementRef, parentCdr: ChangeDetectorRef, parentFormJustToClear: UntypedFormGroup) {
        this.parentFormToValidate = parentFormToValidate;
        this.parentElement = parentElement;
        this.parentCdr = parentCdr;
        this.parentFormJustToClear = parentFormJustToClear;
    }
}
